import { defineTheme } from '../contracts.js';
export const ffsArms = defineTheme({
    id: 'ffs-arms',
    displayName: 'The FFS Arms',
    lifecycle: 'development',
    selectable: false,
    implementation: 'native',
    capabilities: {
        alerts: 'reserved',
        welcomes: 'reserved',
        wam: 'reserved',
        startup: 'reserved',
        achievements: 'reserved',
        viewerSounds: 'reserved',
        privateChatSounds: 'reserved',
    },
});
//# sourceMappingURL=registration.js.map